import React from "react";
import {RemittanceForm} from "../../components/Remittance";

import "../../assets/styles/inventory/addRWR.scss";

import {Container} from "@mui/material";

export default function Remittance() {
    return (
        <Container maxWidth="lg">
            <div className="wrap-factor pt-0">
                <RemittanceForm displayHeader={true}/>
            </div>
        </Container>
    );
}
